import { FC, Fragment } from 'react';

import { SlideOut, SlideOutControls } from '@hsp/react-component-library';

import { ISaveProps } from 'types/pages/audience-builder/shared/save';

import { SaveCloseButton } from './components';
import { useConfiguration } from './hooks';

import cssClasses from './save-slideout.module.scss';

const SaveSlideout: FC<Pick<ISaveProps, 'allowRun' | 'onClose' | 'onSaved' | 'requireChanges' | 'changeStatus'>> = ({
  allowRun = true,
  changeStatus = false,
  onClose,
  onSaved,
  requireChanges,
}) => {
  const { components, formRef, handleClosed, handleError, handleSubmit, handleSubmittedData, isOpen, name } =
    useConfiguration({
      changeStatus,
      onClose,
      onSaved,
    });

  return (
    <>
      <SlideOut
        className={cssClasses.saveSlideOut}
        isOpen={isOpen}
        onClick={(e: MouseEvent) => e.stopPropagation()}
        onClosed={handleClosed}
        title={name()}>
        <form
          onSubmit={handleSubmit(handleSubmittedData, handleError)}
          ref={formRef}>
          {components.map((component, index) => (
            <Fragment key={index}>{component}</Fragment>
          ))}
        </form>
        <SlideOutControls>
          <SaveCloseButton
            allowRun={allowRun}
            onClose={handleClosed}
            requireChanges={requireChanges}
          />
        </SlideOutControls>
      </SlideOut>
    </>
  );
};

export default SaveSlideout;
